import { render, staticRenderFns } from "./OrderRequestList.vue?vue&type=template&id=4b84eb22&scoped=true"
import script from "./OrderRequestList.vue?vue&type=script&lang=js"
export * from "./OrderRequestList.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestList.vue?vue&type=style&index=0&id=4b84eb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84eb22",
  null
  
)

export default component.exports